import { Moment } from 'moment';
import { ISport } from './sport.model';
import { IUser } from './user.model';

export interface IBook {
  id?: number;
  name?: string;
  iconName?: string;
  bannerName?: string;
  bookUrl?: string;
  description?: string;
  createdDate?: Moment;
  lastModifiedDate?: Moment;
  isFree?: boolean;
  sport?: ISport;
  createdBy?: IUser;
  lastModifiedBy?: IUser;
}

export const defaultValue: Readonly<IBook> = {
  isFree: false
};
